export default __webpack_public_path__ + "static/media/close-circle.479ca1a9.svg";